// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\MarinerCloudSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// MarinerCloudSettingsData is the class that MarinerCloudSettings serializes to/from
export interface MarinerCloudSettingsData {
	
	
    BaseEndpoint : string | null;
    Password : string | null;
    Username : string | null;
}

// MarinerCloudSettingsOptions is the class which may be passed to the MarinerCloudSettings constructor to define optional initial data values
export interface MarinerCloudSettingsOptions {
	
	
    BaseEndpoint? : string | null;
    Password? : string | null;
    Username? : string | null;
}

export class MarinerCloudSettings {
	
	
    public BaseEndpoint : DataSignal<string | null>;
    public Password : DataSignal<string | null>;
    public Username : DataSignal<string | null>;

    constructor();
    constructor(data : MarinerCloudSettingsOptions);
    constructor(data: MarinerCloudSettingsOptions | null = null) {
	    
	    
        this.BaseEndpoint = jsonableObservable(S.value<string | null>(data && data.BaseEndpoint !== undefined ? data.BaseEndpoint : null));
        this.Password = jsonableObservable(S.value<string | null>(data && data.Password !== undefined ? data.Password : null));
        this.Username = jsonableObservable(S.value<string | null>(data && data.Username !== undefined ? data.Username : null));
    }

    static key(obj : MarinerCloudSettings) {
        return ;
    }
    
    static dataKey(obj : MarinerCloudSettingsOptions) {
        return ;
    }

    static update(obj : MarinerCloudSettings, data : MarinerCloudSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.BaseEndpoint !== undefined) obj.BaseEndpoint(data.BaseEndpoint);
            if (data.Password !== undefined) obj.Password(data.Password);
            if (data.Username !== undefined) obj.Username(data.Username);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MarinerCloudSettings.ts